
import { reportsApiService } from '@/services/reports-api.service'

const state = () => ({
    isLoading: false,
    pagenatedList: [],
    exceptions: []
});


const getters = {
    isLoading: state => state.isLoading,
    pagenatedList: state => state.pagenatedList
};


const mutations = {
    LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_PAGINATED_LIST(state, payload) {
        state.pagenatedList = payload
    },
    ADD_EXCEPTION(state, payload) {
        state.exceptions.push(payload)
    }
};


const actions = {
    select({ commit }, payload) {
        commit('LOADING', true)
        reportsApiService.getPagenated(payload)
            .then((response) => {
                let data = response.data
                commit('SET_PAGINATED_LIST', data.data)
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}